export default "__VITE_ASSET__CxqWAAxc__"